import { memo, useCallback } from 'react';

import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import Button from '@UI/Button';
import pictures from './assets';
import styles from './Advantages.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { AdvantageData } from '@Pages/PageExpressDesign/type';

interface AdvantagesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  advantages: AdvantageData[];
  onScrollToBlock?: (e: MouseEvent, anchorName: string, tariffId?: string) => void;
}

const Advantages: FC<AdvantagesProps> = (props) => {
  const { advantages, onScrollToBlock, ...restProps } = props;
  const { t } = useTranslation();

  const handleScroll = useCallback(
    (e: MouseEvent) => {
      if (onScrollToBlock) onScrollToBlock(e, 'express-design-first-application');
    },
    [onScrollToBlock],
  );

  return (
    <div {...restProps}>
      <div className={styles.title}>{t('what-you-get')}</div>

      <div className={styles.cards}>
        {advantages.map((item) => {
          const { id, img, title, description } = item;

          return (
            <div key={id} className={styles.card}>
              <Img className={styles.imageWrapper} cnImage={styles.image} src={pictures[img]} />
              <div className={styles.content}>
                <div className={styles.subtitle}>{title}</div>
                <div className={styles.description}>{description}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.buttonWrapper}>
        <Button theme='primary' className={styles.button} onClick={handleScroll}>
          {t('send-request')}
        </Button>
      </div>
    </div>
  );
};

export default memo(Advantages);
